module.exports = __webpack_public_path__ + "static/media/SWSCRC1-30.5744b379.mp3";